import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from '../../utils/API/requestMiddleware';

const regulationAPI = createApi({
    baseQuery: defautBaseQuery,
    reducerPath: 'regulationAPI',
    endpoints: (builder) => ({

        getRegulations: builder.query({
            query: function (params) {
                const { url } = params;

                let { first, rows, sortField, sortOrder, search, ...retVal } = params.params;

                retVal.Pagination = {
                    PageNumber: (first / rows) + 1,
                    PageSize: rows
                };
                retVal.filters = { searchText: search || "" };
                retVal.sortString = '';

                if (sortField) {
                    retVal.sortField = sortField;
                    retVal.sortDesc = sortOrder < 0;
                }

                return {
                    url: params.url,
                    params: { requestData: JSON.stringify(retVal) }
                };
            },
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addRegulation: builder.mutation({
            query: (details) => ({
                url: '/Regulation/AddRegulation',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateRegulation: builder.mutation({
            query: (details) => ({
                url: '/Regulation/UpdateRegulation',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // deleteRegulation: builder.mutation({
        //     query: (details) => ({
        //         url: `/Regulation/DeleteRegulation?id=${details}`,
        //         method: 'DELETE',
        //     }),
        //     transformResponse: transformSucessResponse,
        //     transformErrorResponse: transformErrorResponse
        // }),

        deleteRegulation: builder.mutation({
            query: ({ id, deletedBy }) => ({
                url: `/Regulation/DeleteRegulation?id=${id}&deletedBy=${deletedBy}`,
                method: 'DELETE',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getRegulationById: builder.query({
            query: (details) => ({
                // url: encryptUrlData(`/Regulation/GetRegulationDetailByRegulationID?regulationID=${details}`),
                url: `/Regulation/GetRegulationDetailByRegulationID?regulationID=${details}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllRegulation: builder.query({
            query: () => ({
                url: '/Regulation/GetAllRegulation',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),


        getRegulationProductsByRegulationId: builder.query({
            query: function (params) {
                const { url } = params;

                let { first, rows, sortField, sortOrder, search, regulationId, ...retVal } = params.params;

                retVal.Pagination = {
                    PageNumber: (first / rows) + 1,
                    PageSize: rows
                };
                retVal.filters = { searchText: search };
                retVal.sortString = '';

                if (sortField) {
                    retVal.sortField = sortField;
                    retVal.sortDesc = sortOrder < 0;
                }
                if (regulationId > 0) {
                    retVal.regulationId = regulationId
                }

                return {
                    url: params.url,
                    params: { queryRequest: JSON.stringify(retVal) }
                };
            },
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getRegulationsByChemProductId: builder.query({
            query: (chemProductId) => ({
                url: encryptQueryString(`/Regulation/GetRegulationsByChemProductId?chemProductId=${chemProductId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllCountries: builder.query({
            query: () => ({
                url: '/Regulation/GetAllCountries',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllRegulationTypes: builder.query({
            query: () => ({
                url: '/Regulation/GetAllRegulationTypes',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllRegulatoryOrganizations: builder.query({
            query: () => ({
                url: '/Regulation/GetAllRegulatoryOrganizations',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addBulkRegulationImport: builder.mutation({
            query: (data) => ({
                url: '/Regulation/ImportRegulation',
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
    useLazyGetRegulationsQuery,
    useAddRegulationMutation,
    useUpdateRegulationMutation,
    useDeleteRegulationMutation,
    useLazyGetRegulationByIdQuery,
    useLazyGetAllRegulationQuery,
    useLazyGetRegulationProductsByRegulationIdQuery,
    useLazyGetRegulationsByChemProductIdQuery,
    useGetAllCountriesQuery,
    useGetAllRegulationTypesQuery,
    useGetAllRegulatoryOrganizationsQuery,
    useAddBulkRegulationImportMutation
} = regulationAPI;

export default regulationAPI;